import clsx from 'clsx';
import { truncate } from 'lodash';
import { unescape } from 'lodash';
import React, { useEffect, useState } from 'react';

import { forum_post_path } from '../../../routes';
import { ForumPost } from '../../../utils/backend-api/forumPosts';
import Button from '../../BaseUI/Button';
import styles from './styles.module.scss';

// React version of app/views/articles/components/_share_modal.html.erb
// TODO: Add share url params, see ArticlesController#set_up_sharing
export default function ShareModalContent({
  forumPost,
  title = 'Share forum post',
  subtitle,
  iconSrc,
  onDownloadScreenshot,
}: {
  forumPost: ForumPost;
  title?: string;
  subtitle?: string;
  iconSrc?: string;
  onDownloadScreenshot: (darkMode?: boolean) => void;
}) {
  const [copied, setCopied] = useState(false);
  const [copiedTweet, setCopiedTweet] = useState(false);

  const url = `${window.location.origin}${forum_post_path(forumPost.id)}`;
  const text = `${forumPost.title.trim()}

${unescape(forumPost.comment.snippet.trim())}`;

  const tweet = `${truncate(text, { length: 240 })}

${url}`;

  const copyLink = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
  };

  const copyTweet = () => {
    navigator.clipboard.writeText(tweet);
    setCopiedTweet(true);
  };

  useEffect(() => {
    let timeout;
    if (copied) timeout = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timeout);
  }, [copied]);

  useEffect(() => {
    let timeout;
    if (copiedTweet) timeout = setTimeout(() => setCopiedTweet(false), 1500);
    return () => clearTimeout(timeout);
  }, [copiedTweet]);

  return (
    <div className={styles.shareModalContent}>
      {!!iconSrc && <img src={iconSrc} className={styles.shareIcon} />}
      <div className={styles.shareTitle}>{title}</div>
      {!!subtitle && <div className={styles.shareSubtitle}>{subtitle}</div>}
      <div className="form forum-post-form">
        <div className="form-group">
          <input className="form-control" value={url} disabled={true} />
          <button
            className={clsx(styles.shareCopyButton, 'button button-submit button-small')}
            onClick={copyLink}
          >
            {copied ? 'Copied!' : 'Copy Link'}
          </button>
        </div>

        <div className="form-group">
          <textarea className="form-control" value={tweet} disabled={true} rows={8} />
          <button
            className={clsx(
              styles.shareCopyButton,
              styles.copyTweetButton,
              'button button-submit button-small'
            )}
            onClick={copyTweet}
          >
            {copiedTweet ? 'Copied!' : 'Copy Tweet'}
          </button>
        </div>
      </div>
      <div className={styles.shareScreenshotContainer}>
        <Button variant="muted" onClick={() => onDownloadScreenshot()}>
          Download light mode
        </Button>
        <Button variant="muted" onClick={() => onDownloadScreenshot(true)}>
          Download dark mode
        </Button>
      </div>
    </div>
  );
}
